// extracted by mini-css-extract-plugin
export var closeButton = "_e9-1";
export var closeX = "_e9-3";
export var container = "_e9-0";
export var image = "_e9-2";